<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="(race?.Name ?? '') !== ''"
    >
        <InputBool
            v-if="showCheckbox"
            v-model="useExternalRace"
            class="me-2"
        />
        {{ race?.Name }}
    </div>
</template>

<script setup lang="ts">
import { useEventCommonStoreRef } from '@/stores';
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';

const { Races } = useEventCommonStoreRef();

const props = defineProps<{
    /**
     * The emit ID to display
     */
    value: number | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);

// We only show the checkbox if the race values are different
const showCheckbox = computed(() => {
    return props.row.RaceContestantDetails.RaceName != props.row.RegisteredRaceName;
});

// we need a writable computed for the internalvalue.UseExternalRace
const useExternalRace = computed({
    get: () => !internalValue.value.UseExternalRace,
    set: (value: boolean) => {
        internalValue.value.UseExternalRace = !value;
    },
});

const race = computed(() => {
    if (!props.value) return null;

    return Races.value.find((c) => c.ID === props.value) ?? null;
});
</script>
